module.exports = __webpack_public_path__ + "img/project-manager.bac91d5e.svg";